var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("no-ssr", { attrs: { placeholder: "High trustpilot rating" } }, [
    _c("div", [
      _c(
        "script",
        { attrs: { type: "application/javascript", id: "trustpilot-js" } },
        [
          _vm._v(
            "\n      (function (i, s, o, g, r, a, m) {\n        i[o] =\n          i[o] ||\n          function () {\n            (i[o].q = i[o].q || []).push(arguments);\n          };\n        a = s.createElement(g);\n        m = s.getElementsByTagName(g)[0];\n        a.async = 1;\n        a.src = r;\n        m.parentNode.insertBefore(a, m);\n      })(\n        window,\n        document,\n        'trustpilot',\n        'script',\n        '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',\n      );\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "trustpilot", class: { experiment: _vm.isExperiment } },
        [
          _c(
            "div",
            {
              staticClass: "trustpilot-widget",
              attrs: {
                "data-locale": "en-US",
                "data-template-id": "53aa8807dec7e10d38f59f32",
                "data-businessunit-id": "5a8992b7a8196300010a3682",
                "data-style-width": "192px",
                "data-style-height": "120px",
                "data-theme": "light"
              }
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.trustpilot.com/review/brilliant.org",
                    target: "_blank",
                    rel: "noopener"
                  }
                },
                [_vm._v("Trustpilot")]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }